import { render, staticRenderFns } from "./SelectUser.vue?vue&type=template&id=40808a34&scoped=true&"
import script from "./SelectUser.vue?vue&type=script&lang=js&"
export * from "./SelectUser.vue?vue&type=script&lang=js&"
import style0 from "./SelectUser.vue?vue&type=style&index=0&id=40808a34&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40808a34",
  null
  
)

export default component.exports